import React, { useState } from "react";
export function LoadOrderIndexInput(props) {
    const { item, loadOrder, currentPosition, lockedEntriesCount, onApplyIndex } = props;
    // Valid ranges.
    const startIndex = lockedEntriesCount + 1;
    const maxIndex = loadOrder.length;
    const [inputValue, setInputValue] = useState(currentPosition.toString());
    const handleInputChange = React.useCallback((event) => {
        // Meant to be used as validation only.
        try {
            const newIndex = parseInt(event.target.value, 10);
            setInputValue(newIndex.toString());
        }
        catch (err) {
            setInputValue(currentPosition.toString());
        }
    }, [currentPosition, maxIndex, startIndex]);
    const handleKeyPress = React.useCallback((event) => {
        if (event.key === "Enter") {
            // Apply new index
            let newIndex = parseInt(inputValue, 10);
            newIndex = Math.max(startIndex, Math.min(maxIndex, newIndex));
            onApplyIndex(newIndex);
            setInputValue(newIndex.toString());
        }
        if (event.key === "Escape") {
            // reset
            setInputValue(currentPosition.toString());
        }
    }, [currentPosition, maxIndex, startIndex, inputValue]);
    const handleBlur = React.useCallback(() => {
        // User moved away from the input, reset the index.
        setInputValue(currentPosition.toString());
    }, [currentPosition]);
    React.useEffect(() => {
        setInputValue(currentPosition.toString());
    }, [currentPosition]);
    return props.isLocked(item) ? (React.createElement("p", { className: props.className }, inputValue)) : (React.createElement("div", { className: props.className },
        React.createElement("input", { type: "number", value: inputValue, onChange: handleInputChange, onKeyDown: handleKeyPress, onBlur: handleBlur, min: startIndex, max: maxIndex })));
}
